import React, { useState, ReactElement } from "react";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import { styled } from "@mui/material/styles";
import { StoryPoint } from "../types/StoryPoint";

const StyledPaper = styled(Paper)<{ selected: boolean }>(({ theme, selected }) => ({
    cursor: "pointer",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    position: "absolute",
    top: "0",
    bottom: "0",
    right: "0",
    left: "0",
    color: selected ? theme.palette.primary.contrastText : theme.palette.text.secondary,
    backgroundColor: selected ? theme.palette.secondary.main : theme.palette.background.paper,
    transition: "transform 0.2s",
    userSelect: "none",
    "&:hover": {
        transform: "scale(1.05)",
    },
    "&:active": {
        color: theme.palette.primary.contrastText,
        backgroundColor: theme.palette.secondary.main,
    },
}));


interface CardProps {
    storyPoint: StoryPoint;
    selected: boolean;
    onSelected?: (storyPoint?: StoryPoint) => void;
}

export default function PlayingCard(props: CardProps): ReactElement {
    const [elevation, setElevation] = useState(0);


    function handleMouseUp() {
        if (props.onSelected) {
            if (props.selected) {
                props.onSelected(undefined);
            } else {
                props.onSelected(props.storyPoint);
            }
        }
    }

    return (
        <div style={{ width: '100%', paddingTop: '150%', position: 'relative' }}>
            <StyledPaper
                selected={props.selected}
                elevation={elevation}
                onMouseOver={() => setElevation(3)}
                onMouseLeave={() => setElevation(0)}
                onMouseUp={handleMouseUp}
            >
                <Typography 
                    variant="h3"
                    sx={{
                        ...(props.storyPoint.length >= 3 && {
                            fontSize: {
                                xs: 'clamp(1.50rem, 2.5vw, 2.0rem)',   // 24px-32px: Better for small screens
                                sm: 'clamp(1.25rem, 3vw, 1.75rem)',     // 20px-28px: Comfortable for tablets
                                md: 'clamp(1.25rem, 3vw, 1.50rem)',    // 20px-24px: Good for medium screens
                                lg: 'clamp(1.75rem, 4vw, 2.00rem)',    // 28px-32px: Reduced from 2.5-3.5rem
                                xl: 'clamp(1.75rem, 4vw, 2.00rem)',     // 28px-32px: Reduced from 3-4rem
                            },
                        }),
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        maxWidth: '100%',
                    }}
                >
                    {props.storyPoint}
                </Typography>
            </StyledPaper>
        </div>
    );
}
